"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const db_mapper_1 = __importDefault(require("../base/db-mapper"));
const ctr_summary_model_1 = __importDefault(require("./ctr-summary.model"));
class CTRSummaryMapper extends db_mapper_1.default {
    async getAgentsCTRs(agentID, from, to, filters = {}) {
        return this.query({
            index: 'agentID-initiationTimestamp',
            conditions: {
                agentID,
                initiationTimestamp: {
                    value: to ? [from, to] : from,
                    comparator: to ? 'BETWEEN' : '>',
                },
            },
            filters,
        });
    }
    async getQueueCTRs(queueID, from, to, filters) {
        return this.query({
            index: 'queueID-initiationTimestamp',
            conditions: {
                queueID,
                initiationTimestamp: {
                    value: to ? [from, to] : from,
                    comparator: to ? 'BETWEEN' : '>',
                },
            },
            filters,
        });
    }
    async getRoutingProfileCTRs(routingProfileID, from, to, filters) {
        return this.query({
            index: 'routingProfileID-initiationTimestamp',
            conditions: {
                routingProfileID,
                initiationTimestamp: {
                    value: to ? [from, to] : from,
                    comparator: to ? 'BETWEEN' : '>',
                },
            },
            filters,
        });
    }
    async getInstanceCTRs(instanceID, from, to, filters = {}) {
        return this.query({
            index: 'instanceID-initiationTimestamp',
            conditions: {
                instanceID,
                initiationTimestamp: {
                    value: to ? [from, to] : from,
                    comparator: to ? 'BETWEEN' : '>',
                },
            },
            filters,
        });
    }
    async getHierarchyStructureCTRs(hierarchyStructure, from, to, filters = {}) {
        return this.query({
            index: 'topHierarchyGroupID-initiationTimestamp',
            conditions: {
                topHierarchyGroupID: hierarchyStructure.split('/')[0],
                initiationTimestamp: {
                    value: to ? [from, to] : from,
                    comparator: to ? 'BETWEEN' : '>',
                },
            },
            filters: Object.assign({ hierarchyStructure: {
                    comparator: 'BEGINS_WITH',
                    value: hierarchyStructure,
                } }, filters),
        });
    }
}
exports.default = db_mapper_1.default.registerModel('ctr', ctr_summary_model_1.default, CTRSummaryMapper);
